<template>
<div class="content2">
  <div class="header">
<!--    <el-button @click="toExcelTable">在管项目立案率报表</el-button>-->
    <el-button @click="getExcel2">立案率统计报表</el-button>
    <el-button @click="getExcel">导出模板</el-button>
    <el-button @click="importExcel">导入数据</el-button>
<!--    <el-button @click="printJs">打印</el-button>-->
  </div>
  <div class="body" id="lian-table">
    <table id="lian-table2" width="4110" border="0" cellpadding="0" cellspacing="0" style='min-width:3082.50pt;border-collapse:collapse;table-layout:fixed;'>
<!--      <tr height="32" style='height:24.00pt;mso-height-source:userset;mso-height-alt:480;'>-->
<!--        <td class="xl66" height="32" width="4110" colspan="36" style='height:24.00pt;width:3082.50pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' >广佛分公司在管项目诉讼情况跟进表</td>-->
<!--      </tr>-->
      <tr height="28" style='height:21.00pt;mso-height-source:userset;mso-height-alt:420;'>
<!--        <td class="xl67" height="84" rowspan="3" style='height:63.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' >战区<font class="font5">/</font><font class="font3">分公司</font></td>-->
<!--        <td class="xl68" rowspan="3" style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' >片区</td>-->
        <td class="xl67 table-left" colspan="2" rowspan="3" style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;width: 300px;' >项目</td>
        <td class="xl69" colspan="2" rowspan="2" style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' >1至2年欠费状况</td>
        <td class="xl69" colspan="2" rowspan="2" style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' >两年以上欠费状况</td>
        <td class="xl71" colspan="2" rowspan="2" style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' >年度诉讼计划</td>
        <td class="xl71" colspan="2" rowspan="2" style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' >立案比例</td>
        <td class="xl67" colspan="13" style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' >当月完成情况</td>
        <td class="xl87" colspan="2" style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' >下月诉讼计划</td>
        <td class="xl88" colspan="13" style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' >累计完成情况</td>
        <!--      <td class="xl97" rowspan="3" style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' >有案号</td>-->
        <td class="xl98" colspan="2" rowspan="2" style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' >累计提交户数</td>
      </tr>
      <tr height="28" style='height:21.00pt;mso-height-source:userset;mso-height-alt:420;'>
        <td class="xl67" colspan="2" style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' >当月计划</td>
        <td class="xl67" colspan="2" style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' >提交</td>
        <td class="xl67" colspan="2" style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' >诉调</td>
        <td class="xl67" colspan="2" style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' >立案</td>
        <td class="xl83" colspan="2" style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' >回款</td>
        <td class="xl67" colspan="2" style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' >合计</td>
        <td class="xl86" rowspan="2" style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' >立案率</td>
        <td class="xl67" rowspan="2" style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' >户数</td>
        <td class="xl77" rowspan="2" style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' >金额</td>
        <td class="xl90" colspan="2" style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' >1-{{ last_month }}月累计计划</td>
        <td class="xl67" colspan="2" style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' >提交</td>
        <td class="xl67" colspan="2" style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' >诉调</td>
        <td class="xl67" colspan="2" style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' >立案</td>
        <td class="xl83" colspan="2" style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' >回款</td>
        <td class="xl67" colspan="2" style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' >合计</td>
        <td class="xl86" rowspan="2" style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' >立案率</td>
      </tr>
      <tr height="28" style='height:21.00pt;mso-height-source:userset;mso-height-alt:420;'>
        <td class="xl67" >户数</td>
        <td class="xl77" >金额</td>
        <td class="xl67" >户数</td>
        <td class="xl77" >金额</td>
        <td class="xl67" >户数</td>
        <td class="xl77" >金额</td>
        <td class="xl67" >户数</td>
        <td class="xl77" >金额</td>
        <td class="xl67" >户数</td>
        <td class="xl77" >金额</td>
        <td class="xl67" >户数</td>
        <td class="xl77" >金额</td>
        <td class="xl67" >户数</td>
        <td class="xl77" >金额</td>
        <td class="xl67" >户数</td>
        <td class="xl77" >金额</td>
        <td class="xl83" >户数</td>
        <td class="xl77" >金额</td>
        <td class="xl67" >户数</td>
        <td class="xl77" >金额</td>
        <td class="xl67" >户数</td>
        <td class="xl77" >金额</td>
        <td class="xl67" >户数</td>
        <td class="xl77" >金额</td>
        <td class="xl67" >户数</td>
        <td class="xl77" >金额</td>
        <td class="xl67" >户数</td>
        <td class="xl77" >金额</td>
        <td class="xl83" >户数</td>
        <td class="xl77" >金额</td>
        <td class="xl67" >户数</td>
        <td class="xl77" >金额</td>
        <td class="xl67" >户数</td>
        <td class="xl77" >金额</td>
      </tr>
      <tr height="28" style='height:21.00pt;mso-height-source:userset;mso-height-alt:420;' v-for="(item,index) in pageData.list" :key="index">
<!--        <td class="xl78" height="28" style='height:21.00pt;'>{{item.zq_name}}</td>-->
<!--        <td class="xl78">{{item.pq_name}}</td>-->
        <td class="xl79 table-left" colspan="2">{{item.project_name}}</td>
        <td class="xl80">{{item.one_years_ago_count}}</td>
        <td class="xl80">{{item.one_years_ago_amount}}</td>
        <td class="xl80">{{item.two_years_ago_count}}</td>
        <td class="xl80">{{item.two_years_ago_amount}}</td>
        <td class="xl80">{{item.year_count_plan}}</td>
        <td class="xl81">{{item.year_amount_plan}}</td>
        <td class="xl80">{{item.ss_count_rate}}</td>
        <td class="xl81">{{item.ss_amount_rate}}</td>
        <td class="xl80">{{item.month_count_plan}}</td>
        <td class="xl81">{{item.month_amount_plan}}</td>
        <td class="xl84">{{item.tj_count}}</td>
        <td class="xl85">{{item.tj_amount}}</td>
        <td class="xl84">{{item.st_count}}</td>
        <td class="xl85">{{item.st_amount}}</td>
        <td class="xl84">{{item.la_count}}</td>
        <td class="xl85">{{item.la_amount}}</td>
        <td class="xl84">{{item.hk_count}}</td>
        <td class="xl85">{{item.hk_amount}}</td>
        <td class="xl84">{{item.month_count_actuality}}</td>
        <td class="xl85">{{item.month_amount_actuality}}</td>
        <td class="xl91">{{item.la_rate}}</td>
        <td class="xl84">{{item.next_month_count}}</td>
        <td class="xl85">{{item.next_month_amount}}</td>
        <td class="xl84">{{item.t_month_count_plan}}</td>
        <td class="xl85">{{item.t_month_amount_plan}}</td>
        <td class="xl84">{{item.t_tj_count}}</td>
        <td class="xl84">{{item.t_tj_amount}}</td>
        <td class="xl80">{{item.t_st_count}}</td>
        <td class="xl80">{{item.t_st_amount}}</td>
        <td class="xl80">{{item.t_la_count}}</td>
        <td class="xl92">{{item.t_la_amount}}</td>
        <td class="xl93">{{item.t_hk_count}}</td>
        <td class="xl94">{{item.t_hk_amount}}</td>
        <td class="xl84">{{item.t_month_count_actuality}}</td>
        <td class="xl85">{{item.t_month_amount_actuality}}</td>
        <td class="xl101">{{item.t_la_rate}}</td>
        <!--      <td class="xl78">{{item.project_name}}</td>-->
        <td class="xl78">{{item.total_count}}</td>
        <td class="xl94">{{item.total_amount}}</td>
      </tr>
    </table>
  </div>
  <div class="pagination-wrap">
    <el-pagination background layout="prev, pager, next" :total="pageData.total*1"
                   :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
                   @current-change="pageChange"></el-pagination>
  </div>

  <SelectMonth ref="SelectMonth" />
</div>
</template>

<script>
import PrintOne from "../../../../assets/lib/PrintOne";
import ToExcel from "../common/ToExcel"
import moment from "moment";
import Http from "../common/Http";
import SelectMonth from "./legal/SelectMonth";
import ButlerHttp from "../common/ButlerHttp";
// import FileSaver from 'file-saver'
// import * as XLSX from 'xlsx'


export default {
  name: "LiAnTableStatistics",
  components: {SelectMonth},
  inject:['where','reginWhere'],
  data(){
    return{
      pageData: {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1,
      },
      selectMonthValue:moment().format("M"),
    }
  },
  mounted() {
    this.getList()
  },
  methods:{
    getList() {
      const that = this;
      let where = ERP.reJson(that.where)
      if(that.reginWhere.project_region) where.region_id=that.reginWhere.project_region;
      if(that.reginWhere.project_name) where.project_id=that.reginWhere.project_name;
      if(that.reginWhere.project_ids&&that.reginWhere.project_ids.length) where.project_ids=that.reginWhere.project_ids;
      if(that.reginWhere.area_id) where.area_id=that.reginWhere.area_id;
      if(that.reginWhere.age) where.age=that.reginWhere.age;

      ButlerHttp.post("Litigation/collectionProceeding", {
        ...where,
        page: that.pageData.page,
        page_size: that.pageData.pageSize
      }, res => {
        if (res.code) {
          that.pageData = res.data;
        }
      });
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    getExcel() {
      const that = this;
      let where = ERP.reJson(that.where)
      if(that.reginWhere.project_region) where.region_id=that.reginWhere.project_region;
      if(that.reginWhere.project_name) where.project_id=that.reginWhere.project_name;
      if(that.reginWhere.project_ids&&that.reginWhere.project_ids.length) where.project_ids=that.reginWhere.project_ids;
      if(that.reginWhere.area_id) where.area_id=that.reginWhere.area_id;
      if(that.reginWhere.age) where.age=that.reginWhere.age;

      ButlerHttp.post("Litigation/exportExcelTable", {
        ...where,
        page: that.pageData.page,
        page_size: that.pageData.pageSize
      }, res => {
        if (res.code) {
          window.open(__HTTP__.defaults.baseURL + res.data);
        } else {
          that.$message.error(res.msg || "导出失败");
        }
      });
    },
    getExcel2() {
      const that = this;
      let where = ERP.reJson(that.where)
      if(that.reginWhere.project_region) where.region_id=that.reginWhere.project_region;
      if(that.reginWhere.project_name) where.project_id=that.reginWhere.project_name;
      if(that.reginWhere.project_ids&&that.reginWhere.project_ids.length) where.project_ids=that.reginWhere.project_ids;
      if(that.reginWhere.area_id) where.area_id=that.reginWhere.area_id;

      ButlerHttp.post("Litigation/exportExcelTable2", {
        ...where
      }, res => {
        if (res.code) {
          window.open(__HTTP__.defaults.baseURL + res.data);
        } else {
          that.$message.error(res.msg || "导出失败");
        }
      });
    },
    importExcel(){
      const that=this;
      Http.uploadFile(file=>{
        that.$refs.SelectMonth.show(null,month=>{
          const loading=that.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          ButlerHttp.post("Litigation/importExcelTable", {
            file: file,
            month: month
          }, res => {
            loading.close();
            if (res.code) {
              that.getList();
            } else {
              that.$message.error(res.msg);
            }
          });
        })
      })
    },
    printJs(){
      PrintOne("#lian-table").extend({
        onStart: function () {
          console.log("开始打印")
        },
        onEnd: function () {
          console.log("打印完成")
        }
      })
    },
    toExcelTable(){
      ToExcel.toExcelFile("lian-table2","立案统计")
    },

    // toExcelTable2(){
    //   /* generate workbook object from table */
    //   let wb = XLSX.utils.table_to_book(document.getElementById("lian-table2"));  //表格的id
    //   /* get binary string as output */
    //   let wbout = XLSX.write(wb, {bookType: 'xlsx', bookSST: true, type: 'array'});
    //   try {
    //     FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '立案统计.xlsx')
    //   } catch (e) { if (typeof console !== 'undefined') console.log(e, wbout) }
    //   console.log(wbout)
    // },
  },
  watch:{
    "reginWhere.type_id":function (n,o) {
      this.pageChange(1)
    },
    "reginWhere.project_region":function (n,o) {
      this.pageChange(1)
    },
    "reginWhere.project_name":function (n,o) {
      this.pageChange(1)
    },
    "reginWhere.area_id":function (n,o) {
      this.pageChange(1)
    },
    "where.text":function (n,o) {
      this.pageChange(1)
    },
    "where.start_time":function (n,o) {
      this.selectMonthValue=moment(n).format("M");
      this.pageChange(1)
    },
    "where.end_time":function (n,o) {
      this.pageChange(1)
    }
  },
  computed:{
    last_month(){
      return (moment(this.start_time.replace('-','/')+'/01').get('month')+1)
    },
    start_time(){
      return this.where.start_time
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./LiAnTableStatistics.scss";
.content2{
  .header{
    padding: 10px 0;
  }
  .body{
    width: 100%;
    overflow-x: scroll;

    .table-left{
      position: sticky;
      left: 0;
      background-color: #FFFFFF;
      border: 1px solid #000000;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/LiAnTableStatistics.vue